import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { filter } from 'rxjs';
 
@Component({
  selector: 'app-setting',
  templateUrl: './setting.component.html',
  styleUrls: ['./setting.component.css']
})
export class SettingComponent implements OnInit {
  show: boolean = false;
  selectedTab: string = 'autopay';
  permissions: String[] = environment.billingProps.permissions;
  isNewPaymentExperienceEnabled: boolean = environment.newPaymentExperienceEnableFlag;
  isPaperlessBillingEnabled: boolean = environment.enablePaperlessBilling || false;

  constructor(private router: Router,private route: ActivatedRoute){}
  ngOnInit() {
    if(this.router.url == "/invoices/setting/paymentMethods"){
      this.selectedTab = 'paymentMethods';
    }else if (this.router.url == "/invoices/setting/paperlessBilling") {
      this.selectedTab = 'paperlessBilling';
    } else {
      this.selectedTab = 'autopay';
    }
    this.router.events
      .pipe(
        filter((event: any) => event instanceof NavigationEnd)
      )
      .subscribe((event: NavigationEnd) => {        
        if(event.url == "/invoices/setting/paymentMethods"){
          this.selectedTab = 'paymentMethods';
        }else if (event.url.includes("/invoices/setting/paperlessBilling")) {
          this.selectedTab = 'paperlessBilling';
        } else {
          this.selectedTab = 'autopay';
        }
      });
  }
 
  changeTab(tab: string) {
    if(tab == 'paymentMethods' || 'paperlessBilling')
      this.show = true;
    this.selectedTab = tab;
    this.router.navigate([`${tab}`],{ relativeTo: this.route,state:{} });
  }
}